export default __webpack_public_path__ + "static/media/advisorscreen.5a9461aa.png";